import React, { useState } from 'react'
import { Item, Icon, Card, Button, } from 'semantic-ui-react';

import { BaseUser, Plant, PlantUpdate } from '../../../../src/types';
import SettingsList from './SettingsList';
import SettingsForm from './SettingsForm';
import plantService from '../../services/plant';
import ConfirmDelete from './ConfirmDelete';
import { useHistory } from 'react-router';



const PlantSettings = ({ plant, user, setPlant }: { plant: Plant, user: BaseUser | undefined, setPlant: Function }) => {
    const history = useHistory();
    const [editable, setEditable] = useState(false);

    const updatePlant = async (plantUpdate: PlantUpdate) => {
        const updatedPlant = await plantService.updatePlant(plant.id, plantUpdate)
        setPlant(updatedPlant);
        setEditable(false);
    }

    const deletePlant = async () => {
        await plantService.deletePlant(plant.id);
        history.push('/')
    }

    const waterPlant = async () => {
        await plantService.waterPlant(plant.id);
    }

    const controlPlant = async () => {
        setPlant({
            ...plant,
            watering: !plant.watering
        })
        await plantService.controlPlant(plant.id);
    }

    const calibratePlant = async () => {
        setPlant({
            ...plant,
            calibrating: !plant.calibrating
        })
        await plantService.calibratePlant(plant.id);
    }

    const cancel = () => {
        setEditable(false)
    }

    return (
        <Card fluid>
            <Card.Content>
                <Item.Group>
                    <Item>
                        <Item.Image src={plant.imageURL} size="small" />
                        <Item.Content>
                            <Item.Header>
                                {!editable && <span>{plant.name}</span>}
                                {plant.watering && <Icon name="tint" color="blue" />}
                                {plant.calibrating && <Icon name="sync" color="green" />}
                                {user &&
                                    <Icon
                                        link
                                        name="edit"
                                        onClick={() => setEditable(!editable)}
                                        className="top-right"
                                    />
                                }
                            </Item.Header>
                            <Item.Description>
                                {editable &&
                                    <SettingsForm
                                        plant={plant}
                                        onSubmit={updatePlant}
                                        cancel={cancel}
                                    />
                                }
                                {!editable &&
                                    <SettingsList plant={plant} />
                                }
                            </Item.Description>
                        </Item.Content>
                    </Item>
                </Item.Group>
            </Card.Content>
            {user &&
                <Card.Content extra>
                    <Button icon onClick={waterPlant} color="teal" labelPosition="left">
                        <Icon name="play" />
                        Water Once
                    </Button>
                    {!plant.watering ?
                        <Button icon onClick={controlPlant} color="teal" labelPosition="left">
                            <Icon name="play" />
                            Start Watering
                        </Button>
                        :
                        <Button icon onClick={controlPlant} color="red" labelPosition="left">
                            <Icon name="stop" />
                            Stop Watering
                        </Button>
                    }
                    {!plant.calibrating ?
                        <Button icon onClick={calibratePlant} color="green" labelPosition="left">
                            <Icon name="sync" />
                            Calibrate
                        </Button>
                        :
                        <Button icon onClick={calibratePlant} color="red" labelPosition="left">
                            <Icon name="stop" />
                            Stop Calibrating
                        </Button>
                    }
                    <ConfirmDelete onDelete={deletePlant} plantName={plant.name} />
                </Card.Content>
            }
        </Card>
    )
};

export default PlantSettings;